import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventsProps } from 'services/harvestEvents/types';

// Global Selectors
import { makeSelectHarvestEventHasUnsavedChanges } from 'services/harvestEvents/selectors';

export interface OwnProps extends HarvestEventsProps {
    children: React.ReactElement;
    FallbackComponent?: React.ReactElement;
}

interface ConnectedProps {
    hasUnsavedChanges?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventHasUnsavedChangesGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { children, FallbackComponent, hasUnsavedChanges } = this.props;
        if (hasUnsavedChanges) {
            return FallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    hasUnsavedChanges: makeSelectHarvestEventHasUnsavedChanges()
});

export default connect(mapStateToProps)(
    HarvestEventHasUnsavedChangesGateComponent
);
